var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c("section", { staticClass: "categoryBlock manufacturer" }, [
        _c("div", { staticClass: "contentBox" }, [
          _c("h2", { domProps: { innerHTML: _vm._s(_vm.name) } }),
          _vm._v(" "),
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.manufacturer.comment) }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "imageBox" },
          [_c("lazy-img", { attrs: { "image-url": _vm.imageUrl } })],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }